import { useNavigate } from "react-router-dom";
import  { useEffect } from 'react';


const Logout = () => {

    const nav = useNavigate();
        // localStorage.removeItem("user");
        

        useEffect(() => {
        let session = localStorage.getItem("sessionId");
        // localStorage.removeItem('token')
        // console.log(`/s/${session}`)
        localStorage.removeItem('auth')
        nav(`/s/${session}`);
        }, []);
};


export default Logout;